/**
 * This file is the single source of truth for all tracking-events of this zone.
 * All events MUST be included here and the custom-attributes/dynamic data can be overridden
 * whenever necessary in the place of usage.
 *
 * e.g.:https://gitlab.com/raisin-global/raisin-gmbh/banking/raisin-frontend/-/merge_requests/2428
 */
export const EVENTS = {
    /**
     * @deprecated
     */
    LOGOUT_SUCCEEDED: {
        eventName: 'logout-succeeded',
        object: 'logout',
        action: 'succeeded',
        description: 'logout-succeeded on the header-footer inside customer-portal',
        portal: 'customer-portal',
        boundedContext: 'strong-customer-auth',
        zone: 'customer-portal',
        component: 'header-footer',
    },
    MAIN_NAV_LINK_TAPPED: {
        eventName: 'dynamic - the permalink + action',
        object: 'dynamic - the permalink',
        action: 'tapped',
        description: 'dynamic - eventName on the header-navigation inside customer portal',
        portal: 'customer-portal',
        boundedContext: 'investor-advisory',
        zone: 'customer-portal',
        component: 'header-navigation',
    },
    IBAN_COPIED: {
        eventName: 'iban-copied-tapped',
        object: 'iban-copied',
        action: 'tapped',
        description: 'iban-copied-tapped on the header-navigation inside customer-portal',
        portal: 'customer-portal',
        boundedContext: 'investor-advisory',
        zone: 'customer-portal',
        component: 'header-navigation',
    },
    FOOTER_LEGAL_MENU_LINK_TAPPED: {
        eventName: 'dynamic - the permalink + action',
        object: 'dynamic - the permalink',
        action: 'tapped',
        description: 'dynamic - eventName on the footer-navigation inside customer-portal',
        portal: 'customer-portal',
        boundedContext: 'investor-advisory',
        zone: 'customer-portal',
        component: 'footer-navigation',
    },
    IOS_APP_ICON_BADGE_TAPPED: {
        eventName: 'ios-app-icon-badge-tapped',
        object: 'ios-app-icon-badge',
        action: 'tapped',
        description: 'ios-app-icon-badge-tapped on the footer-navigation inside customer-portal',
        portal: 'customer-portal',
        boundedContext: 'investor-advisory',
        zone: 'customer-portal',
        component: 'footer-navigation',
    },
    ANDROID_APP_ICON_BADGE_TAPPED: {
        eventName: 'android-app-icon-badge-tapped',
        object: 'android-app-icon-badge',
        action: 'tapped',
        description: 'android-app-icon-badge-tapped on the footer-navigation inside customer-portal',
        portal: 'customer-portal',
        boundedContext: 'investor-advisory',
        zone: 'customer-portal',
        component: 'footer-navigation',
    },
    CUSTOMER_REDIRECTED_TO_SOURCE_OF_FUNDS: {
        schema: 'iglu:com.raisin/event_schema/jsonschema/1-0-3',
        eventName: 'customer-missing-financial-information-redirected',
        object: 'customer-missing-financial-information',
        action: 'redirected',
        description: 'Customer is missing source of funds information and is redirected to the page to provide it',
        portal: 'customer-portal',
        zone: 'customer-portal',
        component: 'header-navigation',
        bipsDomain: 'customer',
        context: 'source-of-funds',
    },
    CUSTOMER_REDIRECTED_TO_CDVC: {
        schema: 'iglu:com.raisin/event_schema/jsonschema/1-0-3',
        eventName: 'customer-expired-cdvc-redirected',
        object: 'customer-expired-cdvc',
        action: 'redirected',
        description: ' Customer has CDVC data to be confirmed',
        portal: 'customer-portal',
        zone: 'customer-portal',
        component: 'header-navigation',
        bipsDomain: 'customer',
        context: 'cdvc',
    },
    CUSTOMER_REDIRECTED_TO_REFERENCE_ACCOUNT: {
        schema: 'iglu:com.raisin/event_schema/jsonschema/1-0-3',
        eventName: 'customer-missing-reference-account-redirected',
        object: 'customer-missing-reference-account',
        action: 'redirected',
        description: 'Customer does not have reference account iban and is redirected to the page to provide it',
        portal: 'customer-portal',
        zone: 'customer-portal',
        component: 'header-navigation',
        bipsDomain: 'customer',
        context: 'reference-account-population',
    },
};
export const LOGOUT_SUCCEEDED = {
    eventName: 'logout-succeeded',
    object: 'logout',
    action: 'succeeded',
    description: 'logout-succeeded on the header-footer inside customer-portal',
    portal: 'customer-portal',
    boundedContext: 'strong-customer-auth',
    zone: 'customer-portal',
    component: 'header-footer',
};
//# sourceMappingURL=index.js.map